import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {AttachNoteFileParams, NoteFilesData, NoteFilesDialogData} from "./types/note-files-modal.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {NoteFilesStateService} from "./services/note-files-state.service";
import {PreviewFileUrlsStateService} from "../../../../../../core/services/preview-file-urls-state.service";
import {NoteFilesModalService} from "./services/note-files-modal.service";
import {PreviewFilesStateService} from "../../../../../../core/services/preview-files-state.service";
import {AttachFileParams} from "../../../../../../core/types/file.types";
import { noteFilesResourceParams } from './configs/note-files-modal-config';
import { NOTES_FILE_TYPES } from '../../../../../../core/constants/files.const';
import {FileCardComponent} from "../../../../../../shared/components/ui/file-card/file-card.component";
import {
  FileUploadCardComponent
} from "../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";
import {LoaderComponent} from "../../../../../../shared/components/loader/loader.component";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-note-files-modal',
  imports: [
    BaseModalComponent,
    FileCardComponent,
    FileUploadCardComponent,
    LoaderComponent,
    MatButton
  ],
  templateUrl: './note-files-modal.component.html',
  styleUrl: './note-files-modal.component.scss'
})
export class NoteFilesModalComponent extends BaseModalComponent {
  public noteFilesDialogData = inject<NoteFilesDialogData>(MAT_DIALOG_DATA);
  public noteFilesStateService: NoteFilesStateService = inject(NoteFilesStateService);
  public previewFileUrlsStateService: PreviewFileUrlsStateService = inject(PreviewFileUrlsStateService);
  private noteFilesModalService: NoteFilesModalService = inject(NoteFilesModalService);
  private previewFilesStateService: PreviewFilesStateService = inject(PreviewFilesStateService);

  public readonly noteFilesResourceParams = noteFilesResourceParams;
  public readonly NOTES_FILE_TYPES = NOTES_FILE_TYPES;

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.modalStatesService.openModal(this.noteFilesResourceParams.key);
    await this.getFiles();
    this.noteFilesModalService.getFileUrls();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(this.noteFilesResourceParams.key);
    this.noteFilesStateService.resetNoteFilesState();
    this.previewFilesStateService.resetPreviewFilesState();
    this.previewFileUrlsStateService.resetPreviewFileUrlsState();
  }

  public async handleDelete(isImage: boolean, noteFilesData: NoteFilesData) {
    await this.noteFilesModalService.deleteNoteFile(noteFilesData.id)
      .then(() => {
        this.noteFilesStateService.deleteNoteFilesState(noteFilesData.file.id);
        if (isImage) {
          this.previewFilesStateService.removeFileById(noteFilesData.file.id);
          this.previewFileUrlsStateService.deletePreviewFileUrlById(noteFilesData.file.id);
        }
      });
  }

  public async attachFile({ parentId, fileId }: AttachFileParams): Promise<void> {
    const attachNoteFileParams: AttachNoteFileParams = {
      noteId: parentId,
      fileId: fileId
    };

    await this.noteFilesModalService.attachNoteFile(attachNoteFileParams)
      .then((noteFile) => this.noteFilesStateService.updateNoteFilesState(noteFile));
  }

  private async getFiles(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    await this.noteFilesModalService.getNoteFiles(this.noteFilesDialogData.noteId)
      .then((noteFilesData) => this.noteFilesStateService.setInitialNoteFilesState(noteFilesData))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
